import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CeritifiedPartner from "../../results/availability/ceritifiedPartner";
import LogoImageAvailability from "../../results/availability/logoImage";
import LogoRatingAvailability from "../../results/availability/logoRating";
import LogoStarsAvailability from "../../results/availability/logoStars";
/**
 * Displays the logo, rating stars, and rating value for a renter, along with a certified partner badge if applicable.
 *
 * @param renter - The renter object containing logo image, rating, certification status, and partner URL.
 * @returns A React component rendering the logo, rating, and certification information.
 */
const LogoRatingComponent = ({ renter }) => {
    const { rating, certifiedPartner, image, urlPartner } = renter;
    return (_jsxs("div", { className: "brandstar__container", children: [_jsxs("div", { className: "brandstar", children: [_jsx(LogoImageAvailability, { src: image }), _jsx(LogoStarsAvailability, { rating: rating }), _jsx(LogoRatingAvailability, { rating: rating })] }), certifiedPartner && _jsx(CeritifiedPartner, { urlPartner: urlPartner })] }));
};
export default LogoRatingComponent;
